// External login service configuration
export const EXTERNAL_LOGIN_CONFIG = {
    // Base URL for external login service
    baseURL: "http://customer-api.secureivs.eu/",

    // Client ID for external login service (this is different from our internal client_id)
    externalClientId: "fCnylA3c02srN0AvhQcvAAXj2Nh2yNJ",

    // Available login methods
    loginMethods: {
        SMS: "sms",
        EMAIL: "email",
    },
};

// Function to generate external login URL
export const generateExternalLoginURL = (loginMethod, redirectURI) => {
    const { baseURL, externalClientId, loginMethods } = EXTERNAL_LOGIN_CONFIG;

    return `${baseURL}?client_id=${externalClientId}&login_method=${
        loginMethods[loginMethod]
    }&redirect_uri=${encodeURIComponent(redirectURI)}`;
};
